import { PopupReturnType } from './usePopup'

export const initialPopup: PopupReturnType = {
  state: {
    visible: false,
    title: '',
    width: 420,
    payload: {},
    onCancel: () => undefined
  },
  actions: {
    close: () => undefined,
    open: () => undefined,
    setState: () => undefined
  }
}
